var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clipboard-alert"},[_c('p',[_vm._v("Copiado para área de transferência")])])
}]

export { render, staticRenderFns }